import { Container, createStyles, makeStyles, Theme } from '@material-ui/core';
import { usePreferredLocale } from '@sprinx/react-globalize';
import Loader from '@sprinx/react-loader/Loader';
import React, { FC } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { createApiClient, wrapLayout } from '../../@sprinx/react-after-razzle';
import { AdminStaticContentDto, getAdminStaticPage } from '../../api/adminContent';
import ErrorInternal from '../../components/ErrorInternal';
import usePromiseWithRetry from '../../hooks/usePromiseWithRetry';
import useTranslateWithFallback from '../../hooks/useTranslateWithFallback';
import InfoLayout from '../../layouts/InfoLayout/InfoLayout';

const useStyles = makeStyles((theme: Theme) =>
  createStyles<'root', {}>({
    root: {
      paddingTop: '150px',
      paddingBottom: '150px',
      [theme.breakpoints.down('sm')]: {
        paddingTop: '100px',
      },

      '& img': {
        maxWidth: '100%',
      },
    },
  }),
);

type StaticPageLayoutProps = {
  data: AdminStaticContentDto[];
};

const StaticPageLayout: FC<StaticPageLayoutProps> = () => {
  const classes = useStyles();
  const t = useTranslateWithFallback();
  const group = useRouteMatch<{ group: string }>()?.params.group;
  const locale = usePreferredLocale();

  // NOTE: fetching in after comopnent randomly fails, so we fetch it on FE with a few retries 🤡
  const { data, loading, success } = usePromiseWithRetry(() => getAdminStaticPage(createApiClient(), { group }), 3, [
    group,
  ]);

  if (loading) return <Loader />;

  const currectData = data?.find((i) => i.locales?.includes(locale));

  return (
    <>
      <Container className={classes.root}>
        {success && currectData?.body ? (
          <div dangerouslySetInnerHTML={{ __html: currectData?.body ?? '' }} />
        ) : (
          <div>{t('app/dataIsNotAvailable')}</div>
        )}
      </Container>
    </>
  );
};
StaticPageLayout.displayName = 'StaticPageLayout';

type StaticPageProps = {
  data: AdminStaticContentDto[];
  error?: any;
};

const StaticPage: FC<StaticPageProps> = ({ error, data }) => {
  if (error) return <ErrorInternal error={error} />;
  return <StaticPageLayout data={data} />;
};

export default wrapLayout(StaticPage, InfoLayout) as any;
